import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { getActiveError } from '../store/error/selectors';
import { getActiveLoading } from '../store/loading-status/selectors';
import { useFooter } from './useFooter';
const Footer = styled.div.withConfig({
  displayName: "AppFooterComponent__Footer",
  componentId: "ysyre8-0"
})(["", ""], props => props.theme.embedded && `grid-area: submain;
     display: flex;
     justify-content: center;
     align-items: center;
     text-align: center;
     font-size: 14px;
     height: 80px;
     margin-left: auto;
     margin-right: auto;
     width: \\min(calc(100vw - 2 * 1.25rem), 28rem);`);
export const AppFooterComponent = () => {
  const footer = useFooter();
  const activeLoading = useSelector(getActiveLoading);
  const activeError = useSelector(getActiveError);
  return (!activeLoading || !activeError) && footer ? /*#__PURE__*/_jsx(Footer, {
    children: /*#__PURE__*/_jsx(footer.component, {})
  }) : null;
};